import { render, staticRenderFns } from "./TButton.vue?vue&type=template&id=3b0e05d9&scoped=true&"
import script from "./TButton.vue?vue&type=script&lang=js&"
export * from "./TButton.vue?vue&type=script&lang=js&"
import style0 from "./TButton.vue?vue&type=style&index=0&id=3b0e05d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0e05d9",
  null
  
)

export default component.exports